import React from "react";
import { Line, defaults } from "react-chartjs-2";
import I18n from "../../../i18n/I18n";
import styles from "./Graph.scss";

const Graph = (props: Object) => {
  const labels = props.labels || [""];
  const graphData = props.data || [""];
  defaults.global.defaultFontFamily =
    props.lang === "ar" ? "'Cairo', sans-serif" : "'Proxima Nova', sans-serif";
  const data = {
    labels: labels,
    datasets: [
      {
        lineTension: 0.1,
        backgroundColor: "rgba(255, 245, 192,0.4)",
        borderColor: "rgba(255, 245, 192,0.4)",
        borderCapStyle: "butt",
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: "miter",
        pointBorderColor: "rgba(255, 245, 192,1)",
        pointBackgroundColor: "#fff",
        pointBorderWidth: 0,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: "rgba(251, 232, 101,1)",
        pointHoverBorderColor: "rgba(255, 255, 255,1)",
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: graphData
      }
    ]
  };
  const options = {
    // maintainAspectRatio: false,
    tooltip: {
      mode: "label"
    },
    legend: {
      display: false
    },
    scales: {
      xAxes: [
        {
          ticks: {
            fontColor: "#7a7a7b",
            fontStyle: "500",
            padding: 10,
            autoSkip: false
          },
          gridLines: {
            drawTicks: false,
            display: false,
            zeroLineColor: "transparent"
          }
        }
      ],
      yAxes: [
        {
          ticks: {
            fontStyle: "bold",
            fontColor: "#89876b",
            beginAtZero: true,
            display: false
          },
          gridLines: {
            zeroLineColor: "transparent",
            borderDash: [2, 2],
            color: "#ebedee"
          }
        }
      ]
    }
  };
  return (
    <div className={styles.graphWrapper}>
      <div className={styles.graphTitleWrapper}>
        <h4 className={styles.graphTitle}>
          {I18n.getText("dashboard.graph-title", {}, "Revenue")}
        </h4>
      </div>
      <Line data={data} options={options} height={80} />
    </div>
  );
};

export default Graph;



// WEBPACK FOOTER //
// ./src/components/dashboard/graph/Graph.js